import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const OperationsAircraftCleaningRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--operations--aircraft-cleaning']}>
    <Route index element={<Index />} />
  </SubRouter>
))
